import request from '@/utils/request'

const BaseUrl = '/projectAdjustment'

// 保存or修改立项调整
export function saveOrModifyProjectAdjustment(data) {
  return request({
    url: BaseUrl,
    method: 'post',
    data
  })
}

// 通过id删除立项调整
export function deleteProjectAdjustmentById(id) {
  return request({
    url: `${BaseUrl}/${id}`,
    method: 'delete',
  })
}

// 通过id获取单个立项调整
export function findProjectAdjustmentById(id) {
  return request({
    url: `${BaseUrl}/${id}`,
    method: 'get',
  })
}

// 删除项目奖金
export function removeBonus(id) {
  return request({
    url: `${BaseUrl}/bonus/${id}`,
    method: 'delete',
  })
}

// 删除奖金方案
export function removeBonusPlan(id) {
  return request({
    url: `${BaseUrl}/bonusPlan/${id}`,
    method: 'delete',
  })
}

// 删除立场碑计划
export function removeMilestone(id) {
  return request({
    url: `${BaseUrl}/milestone/${id}`,
    method: 'delete',
  })
}
